'use client';

import { Button } from '@common/components';

import { Image } from '@/components/client';
import { BREAKPOINTS, ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import type { ResponsiveDialogConfig } from '@/stores/ResponsiveDialogStore';
import { getStaticCdnUrl } from '@/utils';
import { APP_DOWNLOAD_QR_SRC } from '@/utils/appDownload';

const TITLE = '참여는 웰로 앱에서만 가능해요!';
const DESCRIPTION =
  '웰로 앱에 로그인하고\n누적 10만원 이상 기부 이력을 확인한 뒤\n신청을 진행해 주세요.';

export const AppOnlyDialogContent = ({ onClose }: { onClose: () => void }) => {
  const router = useCustomRouter();
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);

  if (isDesktopViewport) {
    return (
      <div className="flex justify-center pb-32">
        <div className="relative size-160">
          <Image
            src={APP_DOWNLOAD_QR_SRC}
            alt="웰로 앱 설치 QR 코드"
            fill
            sizes="160px"
            className="object-contain"
            unoptimized
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col break-keep pb-12 pt-8">
      <h2 className="font-700 text-Gray-900 typo-body1">{TITLE}</h2>
      <p className="mt-4 whitespace-pre-line text-Gray-600 typo-body4">
        {DESCRIPTION}
      </p>
      <Image
        src={getStaticCdnUrl('gift-trial/app-hand.png')}
        alt=""
        width={182}
        height={182}
        className="mx-auto my-12"
      />
      <Button
        className="w-full"
        onClick={() => {
          router.push(ROUTES.APP_DOWNLOAD.pathname);
          onClose();
        }}
      >
        앱에서 열기
      </Button>
    </div>
  );
};

export const createAppOnlyDialog = (): ResponsiveDialogConfig => ({
  component: AppOnlyDialogContent,
  drawerType: 'bottom',
  hideDrawerHeader: true,
  ariaLabel: TITLE,
  modalHeader: { title: TITLE, description: DESCRIPTION },
});
